"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var RentPeriodEnding_1 = __importDefault(require("../../../Icons/Notifications/RentPeriodEnding"));
var IconBadge_1 = require("../../../IconBadge");
var i18N = {
    en: {
        description: function (coords, link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The rent on your LAND at",
            react_1.default.createElement(IconBadge_1.IconBadge, { icon: "places", text: coords, onClick: function () { return window.open(link, '_blank'); } }),
            "has ended")); },
        title: 'Rent Period Ended'
    },
    es: {
        description: function (coords, link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El alquiler de su LAND en",
            react_1.default.createElement(IconBadge_1.IconBadge, { icon: "places", text: coords, onClick: function () { return window.open(link, '_blank'); } }),
            "ha terminado")); },
        title: 'Período de alquiler finalizado'
    },
    zh: {
        description: function (coords, link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u571F\u5730\u4E0A\u7684\u79DF\u91D1",
            react_1.default.createElement(IconBadge_1.IconBadge, { icon: "places", text: coords, onClick: function () { return window.open(link, '_blank'); } }),
            "\u7ED3\u675F\u4E86")); },
        title: '租金期结束'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function LandRentalEndedNotificationCmp(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(RentPeriodEnding_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.land, notification.metadata.link))));
}
exports.default = LandRentalEndedNotificationCmp;
